/**
 * Loại Control
 */
export default {
    One: 1,
    Thousand: 1000,
    Million: 1000000,
    Billion: 1000000000,
  };
  